<template>
  <div class="col-md-4">
    <div class="activity-wrap">
      <router-link :to="{ path: activityTypeLink + '/' + activityLink }" class="home-activity-img" :style="{ backgroundImage: 'url(' +require('@/assets/images/' + imageFilename) + ')' }"></router-link>
      <div class="text p-4">
        <router-link :to="{ path: activityTypeLink + '/' + activityLink }"><span class="price">{{price}}</span></router-link>
        <h3>
          <router-link :to="{ path: activityTypeLink + '/' + activityLink }">{{name}}</router-link>
        </h3>
        <p class="description">{{desc.substring(0, 100) + '..' }}</p>        
        <router-link :to="{ path: activityTypeLink + '/' + activityLink }">More Info</router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

.activity-wrap {
  margin-bottom: 30px;

  .home-activity-img {
    display: block;
    width: 100%;
    height: 270px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .text {
    width: 100%;
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-top: none;

    .price {
      padding-left: 15px;
      padding-right: 15px;
      background: #33313b;
      position: absolute;
      top: -23px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      display: inline-block;
      background: #f06a29;
      color: #fff;
      margin: 0 auto;
      padding: 8px;
      font-size: 16px;
      -webkit-border-radius: 40px;
      -moz-border-radius: 40px;
      -ms-border-radius: 40px;
      border-radius: 40px;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      -webkit-transition: all 0.3s ease;
      -ms-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }

    h3 a {
    color: #000000;
    }

    .description {
      font-size: 16px;
      line-height: 1.8;
      font-weight: 400;
      color: #999999;
   }

  }
}

.activity-wrap:hover {
    .text {
      .price {
        padding-left: 15px;
        padding-right: 15px;
        background: #33313b !important;
      }
    }

    h3 a {
      text-decoration: none;
      outline: none !important;
    }
  }
  </style>

<script>
export default {
  name: "HomeActivity",
  props: {
    name: String,
    desc: String,
    price: String,
    imageFilename: String,
    activityTypeLink: String,
    activityLink: String
  }
};
</script>
